// extracted by mini-css-extract-plugin
export default {"card":"TemplateCard_card__ymCMw","card__text":"TemplateCard_card__text__nSQYb","card__chevron":"TemplateCard_card__chevron__cXcjY"};